import PropTypes from 'prop-types';

export default PropTypes.oneOfType([
  PropTypes.object,
  PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      base_amount: PropTypes.number,
      formattedValue: PropTypes.string,
      type: PropTypes.number,
      criteria: PropTypes.number
    })
  )
]);



// WEBPACK FOOTER //
// ./src/model/Types/discountOptions.js